<template>
  <div class="boku">
    <p>
      BONUS: <br />
      All T-Mobile Poland subscribers are able to get a unique 70% off discount
      on Covve Pro TODAY,
      <a :class="{ disabled: clickedClaim }" @click="handleClickClaim()"
        >click here to claim</a
      >.
    </p>
    <form @submit.prevent="bokuPrepareApiCall" v-if="clickedClaim">
      <template v-if="loading">
        Loading... :)
      </template>
      <template v-else>
        <div class="enter-email form">
          <div class="input-group">
            <i class="fas fa-envelope"></i
            ><input
              v-model="email"
              type="email"
              name="email"
              size="20"
              placeholder="Your email"
            />
          </div>
          <div class="part play-now">
            <button
              @click="bokuPrepareApiCall"
              type="submit"
              class="img-a-button"
            >
              <img src="@/assets/btn-claim-discount.png" alt="Submit score" />
            </button>
          </div></div
      ></template>
    </form>
    <!-- <div class="boku-buy-url-iframe" v-if="buyUrl">
      <iframep
        v-show="iframeLoaded"
        :src="buyUrl"
        frameborder="0"
        @load="iframeLoaded = true"
      ></iframe>
    </div> -->
  </div>
</template>

<script>
import { functions } from "@/main.js";
import { validateEmail } from "@/utils";

export default {
  props: ["currentUser"],
  data() {
    return {
      clickedClaim: false,
      email: "",
      buyUrl: "",
      loading: false
    };
  },
  watch: {
    currentUser(newVal, oldVal) {
      if (newVal && newVal.email) {
        this.email = newVal.email;
      }
    }
  },
  beforeMount() {
    this.email = this.currentUser ? this.currentUser.email : "";
  },
  methods: {
    async bokuPrepareApiCall() {
      if (this.loading || !validateEmail(this.email)) return;
      this.loading = true;
      const { data } = await functions.httpsCallable("bokuPrepareApiCall")({
        email: this.email
      });
      window.location = data.buyUrl;
    },
    handleClickClaim() {
      this.clickedClaim = true;
    }
  }
};
</script>

<style lang="scss" scoped >
.boku {
  text-align: center;
  p {
    margin: 40px 0;
  }
}

a {
  padding-bottom: 1px;
}

a.disabled {
  color: darkgrey;
  box-shadow: none;
}

iframe {
  width: 100%;
  height: 380px;
}

.enter-email {
  @include pixelated-border;
  margin: 0 auto;
  padding: 25px;
  border-width: 22px;
  max-width: 60%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background: none;
}

.form {
  .input-group {
    margin: 0 10px;
    input {
      color: inherit;
      font-size: 0.725rem;
      font-family: inherit;
      margin-left: 8px;
      background: none;
      border: none;
      border-bottom: 3px solid $accent-color;
      &::placeholder {
        color: currentColor;
      }
      &:focus {
        outline: none;
      }
    }
  }
}
</style>